import { useState } from 'react'
import { Button } from '@chakra-ui/react'
import type { AgendaDetails } from '@/services/agendas'
import UpsertAgendaDialog from '@/App/Agendas/components/UpsertAgendaDialog'

type Props = {
  agenda: AgendaDetails
}

const EditAgendaButton = ({ agenda }: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Button colorPalette="secondary" size={{ base: 'xs', sm: 'sm' }} onClick={() => setIsOpen(true)}>
        Editar
      </Button>
      {isOpen && (
        <UpsertAgendaDialog
          open
          onOpenChange={setIsOpen}
          agenda={{ id: agenda.id, name: agenda.name, description: agenda.description }}
        />
      )}
    </>
  )
}

export default EditAgendaButton
